import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('businessDispatch.customerName'),
        dataIndex: "name",
        width: "160px",
        align: "center"
    },
    {
        title: i18n.t('customerList.address'),
        dataIndex: "address",
        width: "160px",
        align: "center"
    },
    {
        title: i18n.t('customerList.contactName'),
        dataIndex: "customerContactName",
        width: "160px",
        align: "center"
    },
    {
        title: i18n.t('customerList.contactNumber'),
        dataIndex: "customerContactPhone",
        width: "160px",
        align: "center"
    },
    {
        title: i18n.t('edit'),
        dataIndex: "editCustomer",
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'editCustomer' }
    }

    // {   
    //     title: "客户ID",
    //     dataIndex: "customerId",
    //     width: "40px",
    //     align: "center"
    // },
    // {
    //     title: "公司ID",
    //     dataIndex: "companyId",
    //     width: "120px",
    //     align: "center"
    // },

    // {
    //     title: "类型",
    //     dataIndex: "customerType",
    //     width: "80px",
    //     align: "center"
    // },

    // {
    //     title: "创建时间",
    //     dataIndex: "createdTime",
    //     width: "60px",
    //     align: "center"
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatedTime",
    //     width: "60px",
    //     align: "center"
    // }
];


export {
    columns,
}